import { updateSubAccountAlert } from "./API";
import { extractApiErrorMessage } from 'src/utils/apiErrorUtils';

const UpdateSubAccountAlert = async (coin, alertId, subAccountName, hashrateThreshold, activeWorkersThreshold, emailList, accessToken)  => {
  try {
    const response = await updateSubAccountAlert(coin, alertId, subAccountName, hashrateThreshold, activeWorkersThreshold, emailList, accessToken);    
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, data: extractApiErrorMessage(error) };
  }
};

export default UpdateSubAccountAlert;
